import { Component, input } from '@angular/core';

import { environment } from '@pt/environment';
import { AvatarSize } from '@hglobal/common';

@Component({
  selector: 'pu-avatar',
  standalone: false,
  template: `
    <pu-user-avatar
      [image]="image()"
      [userId]="userId() ?? undefined"
      [size]="size()"
      [nameFirstLetter]="nameFirstLetter()"
      [isHover]="isHover()"
      [optimizationEnabled]="optimizationEnabled"
      [hexagonalDesignEnabled]="hexagonalDesignEnabled"
    />
  `,
})
export class AvatarComponent {
  image = input<string>();
  userId = input<number | null>(null);
  size = input<AvatarSize>(40);
  nameFirstLetter = input<string>();
  isHover = input(false);

  readonly hexagonalDesignEnabled = false;
  readonly optimizationEnabled = environment.imagesOptimizationEnabled;
}
